$(document).ready(function () {

	const downloadSearchForm = $('.download-search-form')

	if (downloadSearchForm.length) {
		submitSearchForm();
	}

	eichlerAjaxPagination();

	function eichlerAjaxPagination(){

		$(document).on('click', '[data-downloadcontentaction]', function (e) {
			e.preventDefault();

			const trigger = $(this);
			const action = trigger.data('downloadcontentaction');
			const parentBlock = $(this).closest('.tx-download-search-results');

			$.ajax({
				url: action,
				type: 'POST',
				dataType: 'html',
				cache: true,
				success: function (response) {
					updateContent(parentBlock, response);
				},
			});
		});
	}

	function submitSearchForm(){
		$(document).on('submit', '.download-search-form', function(event) {
			event.preventDefault();
			var ajaxURL = $(this).data('uri'),
				parentBlock = $(this).closest('.tx-download-search-results');
			$.ajax({
				type: 'POST',
				url: ajaxURL,
				dataType: 'html',
				cache: true,
				data: $(this).serialize(),
				success: function (response) {
					updateContent(parentBlock, response);
				}
			});
		});
	}

	function updateContent(parentBlock, response){
		if(parentBlock.find('.download-tiles').length){
			parentBlock.find('.download-tiles').empty();
			parentBlock.find('.download-tiles').fadeOut(300, function() {
				parentBlock.find('.download-tiles').append($(response).find('.download-tiles').html()).fadeIn(600)
			});
		}

		if(parentBlock.find('.results-count').length){
			parentBlock.find('.results-count').replaceWith($(response).find('.results-count'))
		}

		if(parentBlock.find('.pagination-margin').length){
			parentBlock.find('.pagination-margin').empty();
			parentBlock.find('.pagination-margin').append($(response).find('.pagination-margin').html());
		}
	}
});
